import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 14l4 6h6l-9 -16l-9 16h6l4 -6","key":"svg-0"}]]

const IconTent = createReactComponent('outline', 'tent', 'Tent', __iconNode);

export default IconTent;